
angular.module('bmsApp.directives')
	.directive('photos', [
		'PhotoSvc',
		'ConfigService', function (
			PhotoSvc,
			ConfigService) {
			return {
				restrict: 'E',
				scope: {
					photos: '=',
					isBeforePhoto: '=',
					viewTitle: '=',
				},
				replace: true,
				templateUrl: 'ng/photos/templates/PhotoList.html',
				link: function (scope, element, attrs) {
				},
				controller: function ($scope) {
					if($scope.isBeforePhoto === true || $scope.isBeforePhoto === false){
						$scope.checkBeforeAfterPhoto = true;
					}
					else{
						$scope.checkBeforeAfterPhoto = false;
					}
					$scope.viewPhoto = function(title, photo) {
						PhotoSvc.showViewModal(title, photo);
					};
				}
			};
		}]);
